import { faArrowCircleRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { StyledNavLink } from 'components/link/StyledNavLink';
import { NavLinkProps } from 'react-router-dom';
import styled from 'styled-components';
import { useThemeValues } from 'styles/theme';

const ArrowLinkContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`;

type ArrowLinkProps = NavLinkProps &
    Readonly<{
        /**
         * Optional color for the Arrow Icon.
         * Unless provided, the color will be the link default (blue)
         */
        iconColor?: string | undefined;

        ariaLabel?: string;
    }>;

/**
 * Renders a NavLink with an arrow on the right.
 */
export function ArrowLink({ children, iconColor, ariaLabel, ...rest }: ArrowLinkProps) {
    const { link } = useThemeValues();
    return (
        <ArrowLinkContainer>
            {children}
            <StyledNavLink aria-label={ariaLabel} {...rest}>
                <FontAwesomeIcon
                    aria-label="arrow link icon"
                    icon={faArrowCircleRight}
                    color={iconColor || link}
                    className="mx-10"
                />
            </StyledNavLink>
        </ArrowLinkContainer>
    );
}
